<template>

			<div class="mzixunWrap">
				<div class="mzixunLeft white">
					<div class="abstractIitem">
						<div class="itemTile">
							<h3>院系设置</h3>
						</div>
						<div class="shezhiList">

							<div class="shezhiItem" v-for="(item,index) in yuanxi" v-if="item.majorInfo!=null&&item.majorInfo!=''">
								<h4>{{item.yuanxiName}}</h4>
								<div class="link flex flex-wrap" style="margin-left: 40px;">
									<router-link to=""   v-for="(name,i) in item.majorInfo.split('、')" :key="'index'+i">{{name}}</router-link>
								</div>
							</div>


						</div>
					</div>
				</div>

				<!-- <div class="abstractRight white">
					<div class="abstractIitem">
						<div class="itemTile">
							<h3>其他</h3>
						</div>
						<div class="shezhiList shezhiQita">
							<div class="shezhiItem">
								<h4>经济与管理学部</h4>
								<div class="link flex flex-wrap">
									<router-link to="">元培学院</router-link>
									<router-link to="">燕京学堂</router-link>
									<router-link to="">先进技术研究院</router-link>
									<router-link to="">前沿交叉学科研究院</router-link>
									<router-link to="">中国社会科学调查中心</router-link>
									<router-link to="">分子医学研究所</router-link>
									<router-link to="">科维理天文研究所</router-link>
									<router-link to="">核科学与技术研究院</router-link>
									<router-link to="">北京国际数学研究中心</router-link>
									<router-link to="">海洋研究院</router-link>
									<router-link to="">现代农学院</router-link>
									<router-link to="">人文社会科学研究院</router-link>
								</div>
							</div>
							<div class="shezhiItem">
								<h4>深圳研究生院</h4>
								<div class="link flex flex-wrap">
									<router-link to="">信息工程学院</router-link>
									<router-link to="">化学生物学与生物技术学院</router-link>
									<router-link to="">环境与能源学院</router-link>
									<router-link to="">城市规划与设计学院</router-link>
									<router-link to="">新材料学院</router-link>
									<router-link to="">汇丰商学院</router-link>
									<router-link to="">国际法学院</router-link>
									<router-link to="">人文社会科学学院 </router-link>
								</div>
							</div>
						</div>
					</div>
				</div> -->
			</div>


</template>

<script>
	export default {
		name: "",
		data() {
			return {
        yuanxi:[]
			}
		},
    props:{
      id:{
        type:String,
        default:''
      }
    },
		created(){
      console.log(this.id)
      let _this = this;
      this.$req.queryAllByLimit("vCollegeYuanxi", {
      	pageSize: 0,
      	pageNum: 1,
      	queryObj:{
      		collegeId:this.id
      	}
      }).then(function(response) {
      	_this.yuanxi = response.data
      })
		},
		methods: {

		}


	}
</script>

<style scoped>
	.wrap{ background: #FBFBFB;}
	/* 右边固定 */
	.zuotab{height: auto; display: flex;flex-direction: column;position: fixed;top: 50%;right: 0px;transform:translate(-50%,-50%);}
	.zuotab figure{cursor: pointer; margin: 8px 0; width: 64px;height: 62px;border: 1px solid #FF0000;border-radius: 5px;display: flex;flex-direction: column; align-items: center;justify-content: center;}
	.zuotab figure img{width: 20px;height: 20px;}
	.zuotab figure figcaption{font-size: 12px;font-family: Microsoft YaHei;font-weight: 400;color: #333333;margin-top: 10px;}

</style>



// WEBPACK FOOTER //
// src/views/information/collegeinfo/xyzy_yuanxishezhi.vue